export default {
    routerName: '刊物管理',
    journal: {
        searchName: '検索条件',
        title: 'タイトル',
        type: 'タイプ',
        monthJournal: '月刊',
        dayJournal: '日刊',
        status: '状態',
        open: '有効',
        close: '無効',
        releaseDate: '発刊日付',
        year: '年',
        month: '月',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    sortButton: {
        status: '状態',
        title: 'タイトル',
        releaseYear: '年度',
        createTime: '作成日付',
    },
    table: {
        id: 'ID',
        title: 'タイトル',
        type: 'タイプ',
        releaseDate: '発刊日付',
        createTime: '作成日付',
        sortOrder: 'ソート',
        status: '状態',
    },
};
